import { render, staticRenderFns } from "./AppWidget.vue?vue&type=template&id=a3687172&scoped=true"
import script from "./AppWidget.vue?vue&type=script&lang=js"
export * from "./AppWidget.vue?vue&type=script&lang=js"
import style0 from "./AppWidget.vue?vue&type=style&index=0&id=a3687172&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3687172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3687172')) {
      api.createRecord('a3687172', component.options)
    } else {
      api.reload('a3687172', component.options)
    }
    module.hot.accept("./AppWidget.vue?vue&type=template&id=a3687172&scoped=true", function () {
      api.rerender('a3687172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/designer/widgets/AppWidget.vue"
export default component.exports